import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function FrustrationMethodSection() {
  const benefits = ['Vuelve a comer pan, pizza y dulces sin gluten… sin inflamación y sin fallar en el intento', 'Resultados esponjosos, con sabor real y sin picos de azúcar', 'Resultados desde el primer intento sin desperdiciar ingredientes ni dinero', 'Ingredientes accesibles que puedes conseguir fácilmente'];
  return <section className="py-10 md:py-14 px-4 pt-[0px] pb-[0px] bg-[#0F1827]" data-id="element-143">
      <div className="max-w-xl mx-auto" data-id="element-144">
        {/* Headline */}
        <div className="text-center mb-6" data-id="element-145">
          <h2 className="md:text-[22px] text-[18px] font-[800] font-[Poppins,_sans-serif] text-[#ffff] pt-[10px] pb-[10px]" data-id="element-146">
            ¡PERO NO TE PREOCUPES, YA HICIMOS TODO EL TRABAJO POR TI!
          </h2>
        </div>

        {/* Video */}
        <div className="mb-8 rounded-xl overflow-hidden shadow-lg" data-id="element-147">
          <video src="https://cdn.magicpatterns.com/uploads/fBXAvsETBSmfb5bijJRe2a/20260427-2116-56.4243113.mp4" className="w-full h-auto" controls playsInline autoPlay muted loop preload="metadata" data-id="element-148" />
        </div>

        {/* Benefit List */}
      </div>
    </section>;
}